export const termsStatusTypes = {
  TAC_NEVER_ACCEPTED: 'never',
  TAC_PREVIOUSLY_ACCEPTED: 'previous',
  TAC_CURRENTLY_ACCEPTED: 'current',
};

const idStatusTypes = {
  THIN_FILE: 'THIN_FILE',
  FROZEN: 'FROZEN',
  NOT_IDENTIFIED: 'NOT_IDENTIFIED',
  LOCKED_OUT_PREVIOUSLY_IDENTIFIED: 'LOCKED_OUT_PREVIOUSLY_IDENTIFIED',
  LOCKED_OUT_NOT_IDENTIFIED: 'LOCKED_OUT_NOT_IDENTIFIED',
  PREVIOUSLY_IDENTIFIED: 'PREVIOUSLY_IDENTIFIED',
  CURRENTLY_IDENTIFIED: 'CURRENTLY_IDENTIFIED',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
};

const paymentStatusTypes = {
  VALID: 'VALID',
  INVALID: 'INVALID',
};

const creditStatusTypes = {
  AVAILABLE: 'AVAILABLE',
  NOT_AVAILABLE: 'NULL',
  NO_RECORD_FOUND: 'NO_RECORD_FOUND',
  SERVICE_FAILED: 'SERVICE_FAILED',
  DECEASED: 'DECEASED',
  LACK_OF_INFORMATION: 'LACK_OF_INFORMATION',
  TOO_MANY_RECORDS: 'TOO_MANY_RECORDS',
};

const vantageScoreExclusionStatusTypes = [
  creditStatusTypes.DECEASED,
  creditStatusTypes.LACK_OF_INFORMATION,
  creditStatusTypes.TOO_MANY_RECORDS,
];

const backgroundStatusTypes = {
  AVAILABLE: 'AVAILABLE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  SERVICE_FAILED: 'SERVICE_FAILED',
  NO_SSN_DOB: 'NO_SSN_DOB',
};

export const REPORT_STATUS_AVAILABLE = backgroundStatusTypes.AVAILABLE;
export const REPORT_STATUS_DECEASED = 'DECEASED';
export const REPORT_STATUS_IN_DISPUTE = 'IN_DISPUTE';
export const REPORT_STATUS_MANUAL_REVIEW = 'MANUAL_REVIEW';
export const REPORT_STATUS_LACK_OF_INFORMATION = 'LACK_OF_INFORMATION';
export const REPORT_STATUS_NO_SSN_DOB = backgroundStatusTypes.NO_SSN_DOB;
export const REPORT_STATUS_NOT_AVAILABLE = backgroundStatusTypes.NOT_AVAILABLE;
export const REPORT_STATUS_REAUTHENTICATING = 'REAUTHENTICATING';
export const REPORT_STATUS_REGULATORY_RESTRICTIONS = 'REGULATORY_RESTRICTIONS';
export const REPORT_STATUS_SECURITY_FREEZE = 'SECURITY_FREEZE';
export const REPORT_STATUS_TOO_MANY_RECORDS = 'TOO_MANY_RECORDS';
export const REPORT_STATUS_NO_RECORD_FOUND = 'NO_RECORD_FOUND';

const shareStatusTypes = {
  ENABLED: 'ENABLED',
  WITHDRAWN: 'WITHDRAWN',
  VIEWED: 'VIEWED',
  NULL: 'NULL',
};

const applicantStatusTypes = {
  INVITED: {
    id: 'invited',
    label: 'Invited Application',
  },
  PENDING: {
    id: 'pending',
    label: 'In-Progress Application',
  },
  COMPLETED: {
    id: 'completed',
    label: 'Completed Application',
  },
  ACCEPTED: {
    id: 'accepted',
    label: 'Accepted Application',
  },
  WITHDRAWN: {
    id: 'withdrawn',
    label: 'Withdrawn Application',
  },
};

const applicationStatusTypes = {
  ACTIVE: {
    id: 'active',
    label: 'Active',
  },
  WITHDRAWN: {
    id: 'withdrawn',
    label: 'Withdrawn',
  },
  ACCEPTED: {
    id: 'accepted',
    label: 'Accepted',
  },
  CONDITIONALLY_APPROVED: {
    id: 'conditionally_approved',
    label: 'Conditionally approved',
  },
  INVITED_TO_MOVE_IN: {
    id: 'invited_to_move_in',
    label: 'Approved',
  },
  DECLINED: {
    id: 'declined',
    label: 'Declined',
  },
};

const uiApplicationStatusTypes = {
  COMPLETED: {
    id: 'received',
    label: 'Completed applications',
  },
  IN_PROGRESS: {
    id: 'inProgress',
    label: 'Applications in progress',
  },
  WITHDRAWN: {
    id: 'withdrawn',
    label: 'Withdrawn applications',
  },
  DECLINED: {
    id: 'declined',
    label: 'Declined applications',
  },
  INVITED: {
    id: 'invited',
    label: 'Invited applicants',
  },
  HIDDEN: {
    id: 'hidden',
    label: 'Hidden',
  },
  ACCEPTED: {
    id: 'accepted',
    label: 'Accepted applications',
  },
  RECEIVED: {
    id: 'normalizedReceived',
    label: 'Received applications',
  },
};

const incomeTypes = {
  EMPLOYMENT: 'employment',
  OTHER: 'other',
};

const reportTypes = {
  CREDIT: 'CREDIT',
  BACKGROUND: 'BACKGROUND',
};

const applicationOverallStatusTypes = {
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  CONDITIONALLY_APPROVED: 'conditionally_approved',
  DECLINED: 'declined',
};

export const RESPONSE_TYPE_IP_ADDRESS_FORBIDDEN = 'IP_ADDRESS_FORBIDDEN';
export const RESPONSE_TYPE_GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT';
export const RESPONSE_TYPE_REPORT_EXPIRED = 'REPORT_EXPIRED_ERROR';
export const RESPONSE_TYPE_USER_PREVIOUSLY_IDENTIFIED = 'USER_PREVIOUSLY_IDENTIFIED_ERROR';

const RENTAL_USER_TERMS = 'termsAcceptedZillowRentalUser';

export {
  applicantStatusTypes,
  applicationStatusTypes,
  applicationOverallStatusTypes,
  uiApplicationStatusTypes,
  idStatusTypes,
  paymentStatusTypes,
  shareStatusTypes,
  backgroundStatusTypes,
  creditStatusTypes,
  incomeTypes,
  reportTypes,
  RENTAL_USER_TERMS,
  vantageScoreExclusionStatusTypes,
};
